import { axiosInstance as request } from '@api/rest.service'

export * from './states'
export * from './checklist'
export * from './templates'
export * from './kanban-boards'

/**
 * @description GET /to-dos/create?context={context}
 * @returns {AxiosPromise<any>}
 */
export const GET_TODOS_CREATE = context => request.get(`/to-dos/create?context=${context}`)

/**
 * @description GET /to-dos?filter[board_id]={id}
 * @returns {AxiosPromise<any>}
 */
export const GET_TODOS_FILTERED_BY_BOARD = id => request.get(`/to-dos?filter[board_id]=${id}`)

/**
 * @description GET /to-dos?in_dashboard=true (&filter[owners.id]={id})
 * @returns {AxiosPromise<any>}
 */
export const GET_FILTERED_DASHBOARD_TODOS = (params = {}) => request.get('/to-dos?in_dashboard=true', { params })

/**
 * @description GET /to-dos/{entity}/{entityId}
 * @returns {AxiosPromise<any>}
 */
export const GET_ENTITY_TODOS = (entity, entityId) => request.get(`/to-dos/${entity}/${entityId}`)

/**
 * @description GET /to-dos/{id}
 * @returns {AxiosPromise<any>}
 */
export const GET_TODO = (id, params = {}) => request.get(`/to-dos/${id}`, { params })

/**
 * @description POST /to-dos
 * @returns {AxiosPromise<any>}
 */
export const CREATE_TODO = payload => request.post(`/to-dos`, payload)

/**
 * @description PUT /to-dos/{id}
 * @returns {AxiosPromise<any>}
 */
export const UPDATE_TODO = (id, payload) => request.put(`/to-dos/${id}`, payload)

/**
 * @description DELETE /to-dos/{id}
 * @returns {AxiosPromise<any>}
 */
export const DELETE_TODO = id => request.delete(`/to-dos/${id}`)

/**
 * @description GET /to-dos/owners
 * @returns {AxiosPromise<any>}
 */
export const GET_TODO_OWNERS = () => request.get('/to-dos/owners')
